/* @flow */

import page from 'page';

import * as Account from './modules/account';
import * as Bucket from './modules/bucket';
import * as Catalog from './modules/catalog';
import * as News from './modules/news';
import * as AccountRequests from './modules/user/requests';
import * as AdminEvents from './modules/admin/events';
import * as Campaign from './modules/campaign';
import * as MySpace from './modules/my-space';
import * as User from './modules/user';
import * as Calendar from './modules/calendar';
import * as Survey from './modules/survey';
import * as Messaging from './modules/messaging';

export default function hook() {
  // Account
  page('/account/activate', Account.activate);

  // Bucket
  page('/bucket', Bucket.index);
  page('/bucket/*', Bucket.index);

  // Catalog
  page('/catalog', Catalog.index);
  page('/catalog/*', Catalog.index);

  // News
  page('/news/:id', News.index);

  // Accounts
  page('/accounts/requests', AccountRequests.index);

  // Admin
  page('/admin/events', AdminEvents.index);

  // Campaign
  page('/campaign/:id', Campaign.index);

  // My Space
  page('/mc/my-space/:id', MySpace.index);

  // User
  page('/users/import', User.importation);

  // Calendar
  page('/mc/calendar/events/new', Calendar.index);
  page('/mc/my-space/:user/events/new', Calendar.index);
  page('/mc/calendar/events/:id', Calendar.index);

  // Survey
  page('/mc/surveys/new', Survey.create);
  page('/mc/surveys/:id', Survey.edit);

  // Messaging
  page('/mc/messaging', Messaging.index);
  page('/mc/messaging/*', Messaging.index);

  page.start({
    click: false,
    popstate: false,
  });
}



// WEBPACK FOOTER //
// ./src/router.js